"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepFourOfflineFirstAppointment = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const atome_1 = require("../../../../atome");
const organisms_1 = require("../../../../organisms");
const Appointment_service_1 = __importDefault(require("../../../../../services/Appointment.service"));
const User_service_1 = __importDefault(require("../../../../../services/User.service"));
const hooks_1 = require("../../../../../store/hooks");
const reducers_1 = require("../../../../../store/reducers");
const GlobalStyles_1 = require("../../../../../helper/GlobalStyles");
const doctorslot_enum_1 = require("../../../../../enums/doctorslot.enum");
const atome_2 = require("../../../../atome");
const OfflineFirstAppointment_style_1 = require("../OfflineFirstAppointment.style");
const Breakpoints_1 = require("../../../../../helper/Breakpoints");
const appointmentReducer_1 = require("../../../../../store/reducers/appointmentReducer");
// @ts-ignore
function StepFourOfflineFirstAppointment({ navigation, firstAppointmentInfo, }) {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const userInformation = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    const [error, setError] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const bookAppointment = async () => {
        setLoading(true);
        if (firstAppointmentInfo.selectedSlot) {
            const appointmentData = {
                doctorName: firstAppointmentInfo.doctorName,
                doctorId: firstAppointmentInfo.doctorId,
                startDate: firstAppointmentInfo.selectedSlot.start,
                endDate: firstAppointmentInfo.selectedSlot.end,
                type: doctorslot_enum_1.DOCTOR_SLOT_SUBTYPE.OFFLINE,
                appointmentType: 'firstAppointment',
                practiceId: firstAppointmentInfo.location.id,
                comment: 'Von Patient erstellt',
            };
            // eslint-disable-next-line prettier/prettier
            const doctorResponse = await User_service_1.default.assignDoctorWithType(parseInt(userInformation.id), parseInt(firstAppointmentInfo.doctorId), 'main');
            if (doctorResponse.error) {
                console.log(doctorResponse);
                setLoading(false);
                return;
            }
            dispatch((0, appointmentReducer_1.setAppointmentData)({
                ...appointmentData,
                ...{
                    doctorName: firstAppointmentInfo.doctorName,
                    location: firstAppointmentInfo.location,
                },
            }));
            await async_storage_1.default.setItem('appointmentData', JSON.stringify({
                ...appointmentData,
                ...{
                    doctorName: firstAppointmentInfo.doctorName,
                    location: firstAppointmentInfo.location,
                },
            }));
            await async_storage_1.default.setItem('appointmentDoctor', JSON.stringify(firstAppointmentInfo.doctorId));
            appointmentData.doctorName = appointmentData.doctorName.includes('.')
                ? appointmentData.doctorName.split('. ')[1]
                : appointmentData.doctorName;
            Appointment_service_1.default.createAppointment(appointmentData).then(res => {
                if (res.error) {
                    setError(true);
                    if (res.message.response.status === 401) {
                        dispatch((0, reducers_1.setAuth)({ isAuthenticated: false }));
                        navigation.navigate('Login');
                        setError(false);
                    }
                    console.log(res.message);
                    setLoading(false);
                }
                setLoading(false);
                navigation.navigate('OfflineFirstAppointmentSuccess');
            });
        }
    };
    if (loading) {
        return react_1.default.createElement(atome_1.Loading, null);
    }
    return (react_1.default.createElement(react_native_1.SafeAreaView, null,
        react_1.default.createElement(react_native_1.ScrollView, { style: [OfflineFirstAppointment_style_1.styles.scrollview] },
            Breakpoints_1.isDesktop && react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
            react_1.default.createElement(react_native_1.View, { style: OfflineFirstAppointment_style_1.styles.container },
                react_1.default.createElement(react_native_1.View, { style: OfflineFirstAppointment_style_1.styles.marginTop4px },
                    react_1.default.createElement(atome_2.Icon, { icon: 'checkCircle' })),
                react_1.default.createElement(react_native_1.View, { style: OfflineFirstAppointment_style_1.styles.header },
                    react_1.default.createElement(react_native_1.Text, { style: [OfflineFirstAppointment_style_1.styles.headerTitle, OfflineFirstAppointment_style_1.styles.greenText] }, "Buchung best\u00E4tigen")),
                react_1.default.createElement(react_native_1.View, { style: OfflineFirstAppointment_style_1.styles.locationsContainer },
                    react_1.default.createElement(react_native_1.View, { style: [OfflineFirstAppointment_style_1.styles.confirmationBox, OfflineFirstAppointment_style_1.styles.shadowContainer] },
                        react_1.default.createElement(react_native_1.View, { style: [OfflineFirstAppointment_style_1.styles.positionRelative] },
                            react_1.default.createElement(atome_2.Icon, { icon: 'calendar', size: 60, color: '#3db384' }),
                            react_1.default.createElement(react_native_1.Text, { style: [OfflineFirstAppointment_style_1.styles.selectedDateDay] }, new Date(firstAppointmentInfo.selectedSlot.start).toLocaleString('de-DE', {
                                day: '2-digit',
                            }))),
                        react_1.default.createElement(react_native_1.Text, { style: [OfflineFirstAppointment_style_1.styles.blackText, GlobalStyles_1.globalStyles.marginTop25] }, "Praxis:"),
                        react_1.default.createElement(react_native_1.Text, { style: [OfflineFirstAppointment_style_1.styles.blackText, OfflineFirstAppointment_style_1.styles.boldText] },
                            "nowomed ",
                            firstAppointmentInfo.location.name),
                        react_1.default.createElement(react_native_1.Text, { style: [OfflineFirstAppointment_style_1.styles.blackText, GlobalStyles_1.globalStyles.marginBottom25] }, firstAppointmentInfo.location.address),
                        react_1.default.createElement(react_native_1.Text, { style: [OfflineFirstAppointment_style_1.styles.blackText] }, "Datum / Uhrzeit:"),
                        react_1.default.createElement(react_native_1.Text, { style: [
                                OfflineFirstAppointment_style_1.styles.blackText,
                                OfflineFirstAppointment_style_1.styles.boldText,
                                GlobalStyles_1.globalStyles.marginBottom25,
                            ] },
                            new Date(firstAppointmentInfo.selectedDate).toLocaleString('de-DE', {
                                day: '2-digit',
                                month: 'long',
                                year: 'numeric',
                            }),
                            ",",
                            ' ',
                            new Date(firstAppointmentInfo.selectedSlot.start).toLocaleTimeString([], {
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: false,
                            }),
                            ' ',
                            "-",
                            ' ',
                            new Date(firstAppointmentInfo.selectedSlot.end).toLocaleTimeString([], {
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: false,
                            }),
                            ' ',
                            "Uhr"),
                        react_1.default.createElement(react_native_1.Text, { style: [OfflineFirstAppointment_style_1.styles.blackText] }, "Arzt / \u00C4rztin:"),
                        react_1.default.createElement(react_native_1.Text, { style: [
                                OfflineFirstAppointment_style_1.styles.blackText,
                                OfflineFirstAppointment_style_1.styles.boldText,
                                GlobalStyles_1.globalStyles.marginBottom25,
                            ] }, firstAppointmentInfo.doctorName),
                        react_1.default.createElement(react_native_1.Pressable, { style: OfflineFirstAppointment_style_1.styles.greenButton, onPress: bookAppointment },
                            react_1.default.createElement(react_native_1.Text, { style: [OfflineFirstAppointment_style_1.styles.greenButtonText] }, "Termin jetzt buchen"))))))));
}
exports.StepFourOfflineFirstAppointment = StepFourOfflineFirstAppointment;
